import Button from "./Button";

export default function NavButton(props) {
    return (
        <Button size="small" {...props}/>
    )
}
